import { render, staticRenderFns } from "./stammdaten.vue?vue&type=template&id=1857e00a&scoped=true"
import script from "./stammdaten.vue?vue&type=script&lang=js"
export * from "./stammdaten.vue?vue&type=script&lang=js"
import style0 from "./stammdaten.vue?vue&type=style&index=0&id=1857e00a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1857e00a",
  null
  
)

export default component.exports